import type { ReactNode } from 'react';

import type { EChartsOption } from 'echarts';
import * as echarts from 'echarts';
import ReactECharts from 'echarts-for-react';

import { GraphContainer } from '@/components/GraphContainer';
import { BEHAVIOR_GRAPH_HEIGHT } from '@/configs/Graphs';

type Props = {
  chartGroup?: string;
  option: EChartsOption;
  title: string;
  titleInfo?: string;
  // Optional custom header node (overrides title/titleInfo rendering).
  header?: ReactNode;
  // Override the default chart height (px). Defaults to BEHAVIOR_GRAPH_HEIGHT.
  height?: number;
};

export function BehaviorChart({ chartGroup, option, title, titleInfo, header, height = BEHAVIOR_GRAPH_HEIGHT }: Props) {
  return (
    <GraphContainer title={title} titleInfo={titleInfo} header={header}>
      <ReactECharts
        opts={{ renderer: 'svg' }}
        option={option}
        notMerge
        style={{ height }}
        onChartReady={(chart) => {
          if (chartGroup) {
            chart.group = chartGroup;
            echarts.connect(chartGroup);
          }
        }}
      />
    </GraphContainer>
  );
}
